import { Card, Col, Row, Tooltip } from "antd";
import { QuestionCircleOutlined, RightOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import { Loader } from "./Loader";

type AccountsInProgressProps = {
  data: any;
  isLoading: boolean;
};

export const AccountsInProgress = ({
  data,
  isLoading,
}: AccountsInProgressProps) => {
  const HELP_TEXT =
    "Other Accounts — accounts that lack statuses or have incorrect Last Payment/Next Payment dates.";

  const tooltipStyle: any = useMemo(
    () => ({
      maxWidth: "580px",
    }),
    [],
  );

  const keys: string[] = useMemo(() => (data ? Object.keys(data) : []), [data]);

  return (
    <Card className="dashboard-card acc-in-progress">
      <Row className="justify-space-between">
        <p className="text my-0">Accounts In Progress</p>
        <Tooltip
          placement="top"
          title={HELP_TEXT}
          overlayStyle={tooltipStyle}
          overlayClassName="text-sm"
        >
          <QuestionCircleOutlined className="text-md title logo-cursor" />
        </Tooltip>
      </Row>
      <Row className="w-100 d-block pb-1 h-100">
        {!isLoading ? (
          <Row className="mt-6 d-block">
            {keys.map((key: string, i: number) => (
              <Col key={i} span={12} className="mb-4">
                <Row
                  className="w-100 mb-2 logo-cursor"
                  onClick={data[key].redirectTo}
                >
                  <p className="my-0 text-md title">{data[key].label}</p>
                  <RightOutlined className="ml-2 text-md title" />
                </Row>
                <h3 className="h h3 elipsis">{data[key].value}</h3>
              </Col>
            ))}
          </Row>
        ) : (
          <Loader />
        )}
      </Row>
    </Card>
  );
};
